import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/privacyPolicy/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/privacyPolicy/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/privacyPolicy/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/privacyPolicy/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/privacyPolicy/Delete',
    method: 'delete',
    data,
  })
}

export function GetLatestRecord() {
  return request({
    url: '/privacyPolicy/GetLatestRecord',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
 